import { BlockId, ContentBlock } from "blocks/types";

// V2 Blocks
import { ChatbotBlock } from "blocks/v2/Chatbot/Block";
import {
  Divider,
  Field,
  Form,
  Kanban,
  Links,
  LinksCard,
  MarkdownText,
  Table,
  Zapbot,
} from "blocks/v2";
import { DividerBlock } from "blocks/v2/Divider/Block";
import { FieldBlock } from "blocks/v2/Form/Field/Block";
import { FormBlock } from "blocks/v2/Form/Form/Block";
import { KanbanBlock } from "blocks/v2/Kanban/Block";
import { LinksBlock } from "blocks/v2/Links/Links/Block";
import { LinksCardBlock } from "blocks/v2/Links/LinksCard/Block";
import { MarkdownTextBlock } from "blocks/v2/MarkdownText/Block";
import { TableBlock } from "blocks/v2/Table/Block";
import { ZapbotBlock } from "blocks/v2/Zapbot/Block";
import { MediaBlock } from "blocks/v2/Media/Block";
import { Media } from "blocks/v2/Media";

export function Block({
  block,
  blockId,
}: {
  block: ContentBlock;
  blockId: BlockId;
}) {
  const type = block.type;

  switch (type) {
    case MarkdownText.blockType:
      return <MarkdownTextBlock block={block} blockId={blockId} />;
    case Form.blockType:
      return <FormBlock block={block} blockId={blockId} />;
    case Field.blockType:
      return <FieldBlock block={block} blockId={blockId} />;
    case Table.blockType:
      return <TableBlock block={block} blockId={blockId} />;
    case Kanban.blockType:
      return <KanbanBlock block={block} blockId={blockId} />;
    case Links.blockType:
      return <LinksBlock block={block} blockId={blockId} />;
    case LinksCard.blockType:
      return <LinksCardBlock block={block} blockId={blockId} />;
    case Zapbot.blockType:
      return <ZapbotBlock block={block} blockId={blockId} />;
    case "chatbot-block":
      return <ChatbotBlock block={block} blockId={blockId} />;
    case Media.blockType:
      return <MediaBlock block={block} blockId={blockId} />;
    case Divider.blockType:
      return <DividerBlock block={block} blockId={blockId} />;

    default:
      const _exhaustiveCheck: never = type;
      return _exhaustiveCheck;
  }
}
